import React from 'react'
import feature1 from './images/feature1.jpg'
import feature2 from './images/feature2.jpg'
import feature3 from './images/feature3.jpg'
import { ImLocation2 } from 'react-icons/im'
import { Link } from 'react-router-dom'

const Feature = () => {
    return (
        <>
            <div className="z-50 back   py-12   lg:pt-10 lg:pb-[6rem]">

                <div className="">
                    <div className=""><h1 className='md:text-[2.5rem] text-3xl py-4 lg:mx-[6.5rem] mx-5 md:mx-[3rem] head2 text-[#004A8B]'>Featured Listing</h1>
                    </div>
                    <div className=" border-b-[.4rem] border-b-[#B5D1B3] py-[.1rem] w-[4rem] mx-5 md:mx-[3rem] lg:mx-[6.5rem]"></div>
                </div>

                <div className="lg:mr-[6.6rem] md:mr-[3rem] mx-2 flex justify-end py-5"><button className='text-[#004A8B] py-1 z-10 font-black border-b-2 border-[#004A8B] hover:text-[#B5D1B3] tracking-widest hover:border-[#B5D1B3] text-[13px] '>
                    <Link to='/Forsale' > VIEW ALL LISTINGS</Link> </button></div>

                <div class="grid grid-cols-1 sm:grid-cols-2 px-2 md:px-8 lg:px-[6rem] md:grid-cols-3 md:gap-4 lg:gap-5">

                    <div class="">
                        <div className="group relative">
                            <a href="/Slider">
                                <h1 className='mx-[10px] tracking-wider my-[10px] text-[12px] absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[12px] py-[8px] text-center justify-center'>EOI</h1>
                                <img src={feature1} alt="feature1" />

                                <div className="group-hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]" >
                                    <div className=" border-t border-b border-white text-white absolute top-[6rem] left-[7rem]  ">
                                        <span className="font-bold tracking-wider text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>BOWEN</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>376 Mt Dangar Road</h1></div>
                        <div className=" mx-1 text-gray-400 "><h1>1223 ha</h1></div>
                    </div>

                    <div class="md:py-0 py-8">
                        <div className="group relative">
                            <a href="/Slider">
                                <h1 className='mx-[10px] tracking-wider my-[10px] text-[12px] absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[12px] py-[8px] text-center justify-center'>EOI</h1>
                                <img src={feature2} alt="feature1" />

                                <div className="group-hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]" >
                                    <div className=" border-t border-b border-white text-white absolute top-[6rem] left-[7rem] ">
                                        <span className="font-bold tracking-wider text-[12px] text-center">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>GRIFFITH</h1>
                        </div>
                        <div className=" mx-1 font-black"><h1>1632 Rankins Springs Road</h1></div>
                        <div className=" mx-1 text-gray-400 "><h1>151 ha</h1></div>
                    </div>

                    <div class="">
                        <div className="group relative">
                            <a href='/Slider'>
                                <h1 className='mx-[10px] tracking-wider my-[10px] text-[12px] absolute z-10 text-[#004a8b] font-[600] bg-[#EAF1F7] px-[12px] py-[8px] text-center justify-center'>EOI</h1>
                                <img src={feature3} alt="feature1" />

                                <div className="group-hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]" >
                                    <div className=" border-t border-b border-white text-white absolute top-[6rem] left-[7rem]">
                                        <span className="font-bold text-[12px] tracking-wider text-center">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>RYANSBROOK</h1>
                        </div>
                        <div className=" mx-1 font-black"><h1>139 Douglas Road</h1></div>
                        <div className=" mx-1 text-gray-400 "><h1>8554 ha</h1></div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default Feature